import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';
import DialogForm from '../shared/DialogForm';

export default class ConfirmOrderDialog extends React.Component {
  static propTypes = {
    companyName: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    createOrderFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    renderOrderSummaryChunk: PropTypes.func.isRequired,
    selectedPbData: PropTypes.array.isRequired,
  };

  static defaultProps = {
    companyName: '',
  };

  constructor(props) {
    super(props);
    this.submitOrderFunction = this.submitOrderFunction.bind(this);
  }

  state = {
    page: 1,
  };

  nextPage = () => {
    this.setState({
      page: this.state.page + 1,
    });
  };

  previousPage = () => {
    this.setState({
      page: this.state.page - 1,
    });
  };

  submitOrderFunction = params => {
    const { closeDialogFunction, createOrderFunction } = this.props;

    closeDialogFunction();
    createOrderFunction(params);
  };

  renderOrderSummary = () => {
    const { page } = this.state;
    const {
      companyName,
      closeDialogFunction,
      handleSubmit,
      selectedPbData,
      renderOrderSummaryChunk,
    } = this.props;

    return (
      <div className="container">
        <div className="pre-scrollable order-form info">
          <div style={{ marginBottom: '1rem' }}>
            <h4 style={{ marginBottom: '0.75rem' }}>
              You are about to begin a new order with <i>{companyName}</i>.
            </h4>
            <span>
              A confirmation email will be sent to the Admin. Please review the details below before
              placing the order.
            </span>
          </div>
          {page === 1 ? renderOrderSummaryChunk(selectedPbData) : null}
        </div>
        {page === 1 ? (
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={closeDialogFunction}>
              Continue Editing
            </button>
            <button type="button" className="btn btn-primary" onClick={this.nextPage}>
              Place Order
            </button>
          </div>
        ) : (
          <Form id="createOrder" onSubmit={handleSubmit(this.submitOrderFunction)}>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.previousPage}>
                Continue Editing
              </button>
              <button type="submit" className="btn btn-primary">
                Place Order
              </button>
            </div>
          </Form>
        )}
      </div>
    );
  };

  render() {
    const { dialog, closeDialogFunction } = this.props;

    return (
      <DialogForm
        cancelFunction={closeDialogFunction}
        cancelText="Close"
        content={this.renderOrderSummary()}
        id="confirmOrderDialog"
        show={dialog.show}
        title="Confirmation"
      />
    );
  }
}
